import Vue from 'vue'

import { addCustomWidgetSchema } from '@/components/form-designer/widget-panel/widgetsConfig'
// 注册属性设置组件
import * as PERegister from '@/components/form-designer/setting-panel/propertyRegister'
// 生成组件属性设置
import * as PEFactory from '@/components/form-designer/setting-panel/property-editor-factory'

import printButton from "@/extension/print-button"

addCustomWidgetSchema({
  type: 'printButton',
  icon: 'alert',
  formItemFlag: true,
  options: {
    name: '',
    label: '打印',
    columnWidth: '200px',
    size: '',
    displayStyle: 'block',
    // disabled: false,
    // hidden: false,
    btnType: 'primary',
    plain: false,
    round: false,
    circle: false,
    icon: null,
    suspension: "0",//是否悬浮
    silent: "0",//静默方式
    paperSize: 'A4',//纸张大小
    reportPath: '',//报表路径
    dialogPrint: "0",//弹窗
    interface:'0',
    loopPrint:'0',
    //-------------------
    customClass: '',  //自定义css类名
    //-------------------
    onCreated: '',
    onMounted: '',
    onClick: '',
  }
})  //加载组件Json Schema

Vue.component(printButton.name, printButton)  //注册组件

let typeOptions = [
  { label: 'primary', value: 'primary' },
  { label: 'success', value: 'success' },
  { label: 'warning', value: 'warning' },
  { label: 'danger', value: 'danger' },
  { label: 'text', value: 'text' },
  { label: 'info', value: 'info' },
]
PERegister.registerCPEditor('btnType', 'btnType-editor',
  PEFactory.createSelectEditor('btnType', '显示类型',
    { optionItems: typeOptions }))
// 注册属性编辑框
let suspensionOptions = [
  { label: '是', value: '1' },
  { label: '否', value: '0' }
]
PERegister.registerCPEditor('suspension', 'suspension-editor',
  PEFactory.createRadioGroupEditor('suspension', '是否悬浮', { optionItems: suspensionOptions }))

let silentOptions = [
  { label: '是', value: '1' },
  { label: '否', value: '0' }
]
PERegister.registerCPEditor('silent', 'silent-editor',
  PEFactory.createRadioGroupEditor('silent', '静默方式', { optionItems: silentOptions }))

let paperSizeOptions = [
  { label: 'A4', value: 'A4' },
  { label: 'A5', value: 'A5' }
]
PERegister.registerCPEditor('paperSize', 'paperSize-editor',
  PEFactory.createRadioGroupEditor('paperSize', '纸张大小', { optionItems: paperSizeOptions }))

PERegister.registerCPEditor('reportPath', 'reportPath-editor',
  PEFactory.createInputTextEditor('reportPath', '报表路径'))

let dialogPrintOptions = [
  { label: '是', value: '1' },
  { label: '否', value: '0' }
]
PERegister.registerCPEditor('dialogPrint', 'dialogPrint-editor',
  PEFactory.createRadioGroupEditor('dialogPrint', '是否弹窗打印', { optionItems: dialogPrintOptions }))

  PERegister.registerCPEditor('loopPrint', 'loopPrint-editor',
  PEFactory.createRadioGroupEditor('loopPrint', '是否套打', { optionItems: dialogPrintOptions }))


  PERegister.registerCPEditor('interface', 'interface-editor',
    PEFactory.createRadioGroupEditor('interface', '获取接口地址', { optionItems: [
      { label: '是', value: '1' },
      { label: '否', value: '0' }
    ] }))
